const canUseWebp = () => {
  const elem = document.createElement("canvas");
  if (elem.getContext && elem.getContext("2d")) {
    try {
      return elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
    } catch {
      return false;
    }
  }
  return false;
};

export default canUseWebp;
